import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSubjects } from '../store/subjectsSlice';

const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours

export const useSubjects = () => {
  const dispatch = useDispatch();
  const { data: subjects, loading, error, lastFetched } = useSelector((state) => state.subjects);

  useEffect(() => {
    console.log('useSubjects hook called', { subjects, loading, error, lastFetched });
    // Check if we need to fetch subjects (no data or cache expired)
    if (!subjects.length || !lastFetched || Date.now() - lastFetched > CACHE_DURATION) {
      console.log('Fetching subjects...');
      dispatch(fetchSubjects());
    }
  }, [dispatch, subjects.length, lastFetched]);

  return {
    subjects,
    loading,
    error,
  };
};

export const useSubjectSearch = () => {
  const { subjects, loading } = useSubjects();

  const searchSubjects = (query = '') => {
    if (!query) return subjects;
    
    return subjects.filter((subject) =>
      subject.label.toLowerCase().includes(query.toLowerCase())
    );
  };

  return {
    searchSubjects,
    loading,
  };
};
